import { render, staticRenderFns } from "./AdjustmentStatusBadge.vue?vue&type=template&id=d10d9780&scoped=true"
import script from "./AdjustmentStatusBadge.vue?vue&type=script&lang=js"
export * from "./AdjustmentStatusBadge.vue?vue&type=script&lang=js"
import style0 from "./AdjustmentStatusBadge.vue?vue&type=style&index=0&id=d10d9780&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d10d9780",
  null
  
)

export default component.exports